/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Card } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import {
  Check,
  RefreshCw,
  Info,
  Truck,
  Package,
  Clock,
  MapPin,
  X
} from "lucide-react";
import { useTranslation } from "react-i18next";

export default function () {
  const { t, i18n } = useTranslation();
  const store = useSelector((state) => state.StoreReducer);
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useStoreFormDraft(store);

  // Configure SweetAlert to always appear on top
  const showAlert = (icon, title, text) => {
    return Swal.fire({
     icon,
      title,
      text,
      confirmButtonText: t("activationCompanies.alerts.confirmButton"),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.AmeexId && !data.AmeexKey) {
      await showAlert(
        "warning",
       t("activationCompanies.alerts.missingData.title"),
        t("activationCompanies.alerts.missingData.text")
      );
      return;
    }

    setLoading(true);

    try {
      const response = await axios.get(
        "https://api.ameex.app/customer/Delivery/Parcels/Statuts",
        {
          headers: {
            "C-Api-Id": `${data.AmeexId}`,
            "C-Api-Key": `${data.AmeexKey}`,
          },
        }
      );

      if (response.status === 200) {
        await saveStoreDraft(doc(db, "store", data.id), store, data);

        await showAlert("success", t("activationCompanies.alerts.activationSuccess.title"), "");
      } else {
        await showAlert("error",  t("activationCompanies.alerts.activationFailed.title"), `${response.status}`);
      }
    } catch (error) {
      console.error("Erreur API Ameex Express:", error);

      await showAlert(
        "error",
        t("activationCompanies.alerts.activationError.title"),
        t("activationCompanies.alerts.activationError.text")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeactivate = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: t("activationCompanies.alerts.deactivateConfirm.title"),
      text: t("activationCompanies.alerts.deactivateConfirm.text"),
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: t("activationCompanies.alerts.deactivateConfirm.confirmText"),
      cancelButtonText: t("activationCompanies.alerts.deactivateConfirm.cancelText"),
      backdrop: `rgba(0,0,0,0.7)`,
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });

    if (result.isConfirmed) {
      try {
        const updatedData = { ...data };
        delete updatedData.AmeexKey;
        delete updatedData.AmeexId;

        await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
        setData(updatedData);

        await Swal.fire({
         icon: "success",
          title: t("activationCompanies.alerts.deactivateSuccess.title"),
          text: t("activationCompanies.alerts.deactivateSuccess.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
          customClass: {
            popup: "swal-popup-on-top",
          },
        });
      } catch (error) {
        console.error("Error during deactivation:", error);
        await Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.deactivateError.title"),
          text: t("activationCompanies.alerts.deactivateError.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    }
  };
  return (
<div className="min-h-[400px] h-fit p-6 dark:!bg-[#181819] dark:!text-gray-200">
  <h3 className="text-lg font-semibold text-[#9e68ba] mb-3">
    {t("activationCompanies.ameex.title")}
  </h3>
  <Form onSubmit={handleSubmit}>
    <div className="mb-4">
      <p className="font-medium text-gray-700 mb-3 dark:!text-gray-300">
        {t("activationCompanies.ameex.accountIdLabel")}
      </p>
      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder={t("activationCompanies.ameex.accountIdPlaceholder1")}
          value={data.AmeexId || ""}
          onChange={(e) => setData({ ...data, AmeexId: e.target.value })}
          className="mb-3 border-gray-300 rounded-lg p-2 
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200
                     focus:ring-2 focus:ring-[#9e68ba]"
          style={{ direction: "ltr", textAlign: "left" }}
        />
        <Form.Text className="text-muted dark:!text-gray-400">
          {t("activationCompanies.ameex.accountIdHint1")}
        </Form.Text>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          placeholder={t("activationCompanies.ameex.accountIdPlaceholder2")}
          value={data.AmeexKey || ""}
          onChange={(e) => setData({ ...data, AmeexKey: e.target.value })}
          className="mb-3 border-gray-300 rounded-lg p-2 
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200
                     focus:ring-2 focus:ring-[#9e68ba]"
          style={{ direction: "ltr", textAlign: "left" }}
        />
        <Form.Text className="text-muted dark:!text-gray-400">
          {t("activationCompanies.ameex.accountIdHint2")}
        </Form.Text>
      </Form.Group>
    </div>

    {/* Tips Section */}
    <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] mb-4 
                    dark:!bg-[#181919] dark:!border-[#3c3a3d]">
      <h4 className="font-medium text-xl text-[#9e68ba] mb-2 d-flex align-items-center">
        <Info size={18} className="ml-2" />
        {t("activationCompanies.ameex.tipsTitle")}
      </h4>
      <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
        <li className="d-flex align-items-start mb-2">
          <Truck size={16} className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0" />
          <span>{t("activationCompanies.ameex.tips.tracking")}</span>
        </li>
        <li className="d-flex align-items-start mb-2">
          <Package size={16} className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0" />
          <span>{t("activationCompanies.ameex.tips.packing")}</span>
        </li>
        <li className="d-flex align-items-start mb-2">
          <Clock size={16} className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0" />
          <span>{t("activationCompanies.ameex.tips.sku")}</span>
        </li>
        <li className="d-flex align-items-start">
          <MapPin size={16} className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0" />
          <span>{t("activationCompanies.ameex.tips.coverage")}</span>
        </li>
      </ul>
    </div>

    <div className="d-flex justify-content-between mt-4">
      <Button
        type="submit"
        disabled={loading}
        className="d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "rgb(141, 93, 167)",
          borderColor: "rgb(141, 93, 167)",
          opacity: loading ? 0.7 : 1,
          cursor: loading ? "not-allowed" : "pointer",
          transition: "all 0.2s ease",
          borderRadius: "0.5rem",
          padding: "0.5rem 1.5rem",
          minWidth: "150px",
        }}
      >
        {loading ? (
          <>
            <RefreshCw className="animate-spin ml-2" size={18} />
            {t("activationCompanies.ameex.activating")}
          </>
        ) : (
          <>
            <Check className="ml-2" size={18} />
            {t("activationCompanies.ameex.activate")}
          </>
        )}
      </Button>

      <Button
        variant="danger"
        className="d-flex align-items-center justify-content-center"
        onClick={handleDeactivate}
        style={{
          borderRadius: "0.5rem",
          padding: "0.5rem 1.5rem",
          minWidth: "150px",
        }}
      >
        <X className="ml-2" size={18} />
        {t("activationCompanies.ameex.deactivate")}
      </Button>
    </div>
  </Form>
</div>

  );
}
